export default __webpack_public_path__ + "static/flowers-3cb3b65e8b7945f0e4ec2271951ae2bf.png";